import type Store from '@ember-data/store';
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type CurrentUser from 'donor-elf-web/services/current-user';
import type FundsService from 'donor-elf-web/services/funds-service';
import type { Changeset } from 'ember-changeset';

interface ControllerArgs {
  model: { changeset: Changeset };
}

enum Statuses {
  IDLE = 'idle',
  SAVING = 'saving',
  SAVED = 'saved',
}

export default class QuestionController extends Controller {
  declare model: ControllerArgs['model'];

  @service declare currentUser: CurrentUser;
  @service declare fundsService: FundsService;
  @service declare store: Store;

  @tracked error: any = null;
  @tracked showValidationErrors = false;
  @tracked status: Statuses = Statuses.IDLE;

  reset() {
    this.error = null;
    this.status = Statuses.IDLE;
    this.showValidationErrors = false;
  }

  save = async () => {
    try {
      let changeset = this.model.changeset;

      this.showValidationErrors = false;

      await this.fundsService.confirmValidFundToken();
      await changeset.validate();

      if (changeset.isValid) {
        this.status = Statuses.SAVING;
        await changeset.save();
        this.status = Statuses.SAVED;
      } else {
        this.showValidationErrors = true;
      }
    } catch (error) {
      this.status = Statuses.IDLE;
      this.error = error;
    }
  };
}
